/* eslint-disable react/jsx-props-no-spreading */
import DuotoneIcon from '2-core-elements/Icon/DuotoneIcon';
import { type GoogleMapPinProps, type IconLists } from './ListingMapHelpers';

export interface ItemPinProps extends GoogleMapPinProps {
    icon: IconLists;
    onClick?: () => void;
    isActive?: boolean;
    iconSet?: 'asset' | 'property';
    noHover?: boolean;
    ariaLabel?: string;
}

type ItemPinSkin = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';

export const getAssetSkin = (icon: ItemPinProps['icon']): ItemPinSkin => {
    switch (icon) {
    case 'water-01':
    case 'pipeline-02':
    case 'electricity':
        return '2';
    case 'wind-power-01':
    case 'gas-01':
    case 'pipeline-01':
    case 'solar-power-02':
    case 'diversity':
        return '3';
    case 'digital':
    case 'data-01':
        return '4';
    case 'education':
    case 'healthcare':
    case 'government':
    case 'rail':
        return '5';
    // airports-01
    // seaport-04
    // road-01
    case 'map':
        return '6';
    default: return '1';
    }
};

export const getPropertySkin = (icon: ItemPinProps['icon']): ItemPinSkin => {
    switch (icon) {
    case 'education':
        return '2';
    case 'healthcare':
        return '5';
    case 'housing-living':
        return '3';
    case 'industrial':
        return '1';
    case 'office-asset':
        return '4';
    case 'retail':
        return '7';
    case 'social-infrastructure':
        return '8';
    case 'mixed-use':
        return '6';
    default: return '1';
    }
};

export const getSkinByIconSet = (icon: ItemPinProps['icon'], iconSet?: ItemPinProps['iconSet']): ItemPinSkin => {
    if (iconSet === 'property') {
        return getPropertySkin(icon);
    }
    return getAssetSkin(icon);
};


const ItemPin = ({ onClick, isActive = false, style, icon = 'healthcare', iconSet = 'asset', noHover, ariaLabel }: ItemPinProps): JSX.Element => {
    const skin = getSkinByIconSet(icon, iconSet);

    return (
        <button
            type="button"
            className={`item-pin skin-${skin} ${isActive ? 'is-active' : ''} ${noHover ? 'no-hover' : ''}`}
            onClick={onClick}
            style={style}
            aria-label={ariaLabel}

        >
            <div className="item-pin-loader">
                <div className="item-pin-loader-anim">
                    <div className="item-pin-loader-item" />
                    <div className="item-pin-loader-item" />
                </div>
            </div>
            <DuotoneIcon icon={icon} />
        </button>
    );
};

export default ItemPin;
